import type { ActionExecution } from './runActionWithAsyncFallback';
import type { MailboxType } from 'owa-client-types';
import { MailboxInfoError } from '../MailboxInfoError';
import { logGreyErrorFromAccounts } from 'owa-account-analytics';

export function logMailboxInfoNotFromStore(
    execution: ActionExecution,
    mailboxType: MailboxType
): void {
    const error = new MailboxInfoError('MailboxInfo not from store');

    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    logGreyErrorFromAccounts('MailboxInfoNotFromStore', undefined, error, {
        execution,
        mailboxType,
    });
}
